import { render } from "./pending_requisition.vue?vue&type=template&id=ce266124"
import script from "./pending_requisition.vue?vue&type=script&lang=js"
export * from "./pending_requisition.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\software.icarusbd.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__